import { Injectable, inject } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';
import { IndexedDBService } from '~/core/services/indexed-db-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard {
  auth = inject(AuthenticationService);
  router = inject(Router);

  constructor() {}

  private async checkIfLoggedAndReturn() {
    const loggedIn = !!AuthenticationService.currentUser;

    AuthenticationService.currentUser = await IndexedDBService.getItem(AuthenticationService.localUserStoragePath);
    this.auth.loggedInSubject.next(loggedIn);

    if (!loggedIn) {
      this.router.navigate(['/']);
    }

    return loggedIn;
  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkIfLoggedAndReturn();
  }

  canLoad(): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkIfLoggedAndReturn();
  }
}
